import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "p-grid p-m-0"
}
const _hoisted_2 = { class: "p-col-6" }
const _hoisted_3 = { class: "p-col-6" }
const _hoisted_4 = { class: "p-col-6" }
const _hoisted_5 = { class: "p-col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_GlossaryUsageNavigationCard = _resolveComponent("GlossaryUsageNavigationCard")
  const _component_GlossaryUsageLinkCard = _resolveComponent("GlossaryUsageLinkCard")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate",
          class: "kn-progress-bar"
        }))
      : _createCommentVNode("", true),
    (!_ctx.linkTableVisible)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_GlossaryUsageNavigationCard, {
              class: "p-m-2",
              type: 'document',
              items: _ctx.documents,
              glossaryChanged: _ctx.glossaryChanged,
              onInfoClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDocumentInfo($event))),
              onLinkClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onLinkClicked($event))),
              onSelected: _ctx.onDocumentsSelected
            }, null, 8, ["items", "glossaryChanged", "onSelected"])
          ]),
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_GlossaryUsageNavigationCard, {
              class: "p-m-2",
              type: 'dataset',
              items: _ctx.datasets,
              glossaryChanged: _ctx.glossaryChanged,
              onInfoClicked: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDatasetInfo($event))),
              onLinkClicked: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onLinkClicked($event))),
              onSelected: _ctx.onDatasetsSelected
            }, null, 8, ["items", "glossaryChanged", "onSelected"])
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_GlossaryUsageNavigationCard, {
              class: "p-m-2",
              type: 'businessClass',
              items: _ctx.businessClasses,
              glossaryChanged: _ctx.glossaryChanged,
              onInfoClicked: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showBusinessClassInfo($event))),
              onLinkClicked: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onLinkClicked($event))),
              onSelected: _ctx.onBusinessClassesSelected
            }, null, 8, ["items", "glossaryChanged", "onSelected"])
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_GlossaryUsageNavigationCard, {
              class: "p-m-2",
              type: 'table',
              items: _ctx.tables,
              glossaryChanged: _ctx.glossaryChanged,
              onInfoClicked: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showTableInfo($event))),
              onLinkClicked: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onLinkClicked($event))),
              onSelected: _ctx.onTablesSelected
            }, null, 8, ["items", "glossaryChanged", "onSelected"])
          ])
        ]))
      : (_openBlock(), _createBlock(_component_GlossaryUsageLinkCard, {
          key: 2,
          title: _ctx.linkTableTitle,
          class: "p-m-2",
          items: _ctx.linkTableItems,
          words: _ctx.selectedLinkItemWords,
          treeWords: _ctx.selectedLinkItemTree,
          showModelColumn: _ctx.showModelColumn,
          onClose: _ctx.onLinkTableClose,
          onSelected: _ctx.onLinkItemSelect
        }, null, 8, ["title", "items", "words", "treeWords", "showModelColumn", "onClose", "onSelected"]))
  ]))
}